import { useMemo } from "react";

const useBackendUrl = () => {
  const backendUrl = useMemo(() => {
    // Optionaler Override fuer lokale Entwicklung gegen ein bestimmtes Backend
    // (z.B. anderer Port als 3001). In PROD nie gesetzt.
    if (process.env.NEXT_PUBLIC_BACKEND_URL_OVERRIDE) {
      return process.env.NEXT_PUBLIC_BACKEND_URL_OVERRIDE.replace(/\/+$/, "");
    }
    // Check if running in the browser
    if (typeof window !== "undefined") {
      const hostname = window.location.hostname;

      if (hostname === "localhost" || hostname === "192.168.0.79") {
        return "http://localhost:3001/api"; // Local backend URL
      } else if (hostname === "dev-ael-next-frontend.vercel.app") {
        return "https://ael-backend-development-402643550069.europe-west3.run.app/api"; // Dev backend URL
      } else {
        return "https://ael-backend-main-402643550069.europe-west3.run.app/api"; // Production backend URL
      }
    }

    return "https://ael-backend-main-402643550069.europe-west3.run.app/api";
  }, []);

  return backendUrl;
};

export default useBackendUrl;
